import Vconsole from 'vconsole'

if(location.search.indexOf('isDev') > -1) {
  new Vconsole()
}



// WEBPACK FOOTER //
// ./src/utils/vconsole.js